module.exports = __webpack_public_path__ + "static/media/zwz_logo.9bc6916f.png";